import { ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";

interface Segment {
  segment_name: string;
  description: string;
  key_characteristics: string[];
  primary_challenges: string[];
  motivations: string[];
}

interface Props {
  targeted_segments: Segment[];
}

export default function PatientSegment({ response }: any) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);


  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <div className="h-[90vh] max-w-xl border rounded-xl border-gray-300 overflow-y-auto pn_scroller pb-2">
      <h2 className="text-lg font-semibold py-3 px-3 border-b border-gray-300 text-gray-800">
        Targeted Patient Segments
      </h2>

      <div className="space-y-2 px-2 mt-3">
        {response?.targeted_segments.map((segment:any, index:any) => (
          <div
            key={index}
            className="bg-white shadow-sm border rounded-2xl p-3 transition-all"
            onClick={() => toggle(index)}
          >
            {/* Header */}
            <div
              className="flex justify-between items-center cursor-pointer"
              
            >
              <h3 className="text-md font-semibold text-gray-900">
                {segment.segment_name}
              </h3>
              <button className="text-gray-500">
                {openIndex === index ? <ChevronDown className="w-2 h-2" /> : <ChevronRight className="w-2 h-2" />}
              </button>
            </div>

            {/* Description */}
            <p className="text-gray-600 mt-2 text-xs">{segment.description}</p>

            {/* Expandable Section */}
            {openIndex === index && (
              <div className="mt-4 space-y-3">
                {/* Characteristics */}
                <div>
                  <h4 className="font-semibold text-gray-800 mb-1 text-sm">
                    Key Characteristics:
                  </h4>
                  <ul className="list-disc ml-6 text-gray-700 space-y-1 text-xs">
                    {segment.key_characteristics.map((item:any, i:any) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>

                {/* Challenges */}
                <div>
                  <h4 className="font-semibold text-gray-800 mb-1 text-sm">
                    Primary Challenges:
                  </h4>
                  <ul className="list-disc ml-6 text-gray-700 space-y-1 text-xs">
                    {segment.primary_challenges.map((item:any, i:any) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>

                {/* Motivations */}
                <div>
                  <h4 className="font-semibold text-gray-800 mb-1 text-sm">
                    Motivations:
                  </h4>
                  <ul className="list-disc ml-6 text-gray-700 space-y-1 text-xs">
                    {segment.motivations.map((item:any, i:any) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>

               <div className="space-y-2 text-sm text-gray-600">
                  <div className="flex justify-between">
                    <span className="font-semibold text-gray-800 text-sm">Region</span>
                    <span className="text-gray-700 text-xs">{segment?.region_name || "-"}</span>
                  </div>

                  <div className="flex justify-between">
                    <span className="font-semibold text-gray-800 text-sm">Age Range</span>
                    <span className="text-gray-700 text-xs">{segment?.age_range || "-"}</span>
                  </div>

                  <div className="flex justify-between">
                    <span className="font-semibold text-gray-800 text-sm">Predominant Gender</span>
                    <span className="first-letter:uppercase text-gray-700 text-xs">{segment?.predominant_gender || "-"}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
